import { css } from 'styled-components';
import token from 'styled-token';
import { StyledListItem } from '../../components/ListItem/ListItem.styles';
import { listResetMixin } from '../listResetMixin';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  if (appearance === 'none') {
    return '';
  }
  return token({
    borderColor: 'List.borderColor',
    borderWidth: 'List.borderWidth',
    paddingLeft: 'List.paddingLeft',
    itemPaddingTop: 'List.Item.paddingTop',
    itemPaddingRight: 'List.Item.horizontalTable.paddingRight',
    itemPaddingBottom: 'List.Item.paddingBottom',
    itemPaddingLeft: 'List.Item.horizontalTable.paddingLeft'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      paddingLeft = _ref.paddingLeft,
      itemPaddingTop = _ref.itemPaddingTop,
      itemPaddingRight = _ref.itemPaddingRight,
      _ref$itemPaddingBotto = _ref.itemPaddingBottom,
      itemPaddingBottom = _ref$itemPaddingBotto === void 0 ? 0 : _ref$itemPaddingBotto,
      itemPaddingLeft = _ref.itemPaddingLeft;
    if (appearance === 'horizontalTable') {
      return css(["", "{padding-left:", ";padding-right:", ";&:not(:last-child){border-bottom:", "px solid ", ";}}"], StyledListItem, itemPaddingLeft ? itemPaddingLeft + "px" : spaceMixin('sm'), itemPaddingRight ? itemPaddingRight + "px" : spaceMixin('sm'), borderWidth, borderColor);
    }
    var styles = [css(["padding-left:", ";", " ", "{&:first-child{padding-top:", "px;}&:last-child{padding-bottom:", ";}}"], paddingLeft ? paddingLeft + "px" : spaceMixin('lg'), StyledListItem, StyledListItem, spaceMixin(itemPaddingTop, function (space) {
      return space.value * 2;
    }), itemPaddingBottom)];
    if (appearance === 'bullet') {
      styles.push(css(["", "{list-style-type:disc;}"], StyledListItem));
    }
    if (appearance === 'number') {
      styles.push(css(["", "{list-style-type:decimal;}"], StyledListItem));
    }
    return styles;
  })(props);
};

/** @class ListMixin */
/** @method */
export var ListMixin = function ListMixin(props) {
  return token('List.fontType', function (fontType) {
    return [listResetMixin(props), typographyMixin(Object.assign({
      fontType: fontType
    }, props)), appearanceCSS(props), spacingMixin(props)];
  })(props);
};